<template>
    <div v-if="amount > 0">
        <div class="timesheets-to-approve hidden-mobile">
            <heading colour="white" size="medium" no-margin>{{ amount }} Timesheets Awaiting Approval</heading>
            <p>There are {{ amount }} timesheets awaiting approval.</p>
            <a :href="url">View Timesheets</a>
        </div>
        <div class="hidden-desktop dashboard-component-icon">
            <heading colour="white" size="medium">Timesheets To Approval</heading>
            <a :href="url"><i class="fa fa-clock-o"></i></a>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                amount: 0
            }
        },
        props: ['url'],
        computed: {},
        watch: {},
        methods: {
            getTimesheets() {
                var that = this;
                var params = {};
                params.submitted_only = true;

                axios.get(appUrls.timesheets.to_approve,{params:params})
                    .then(response => {
                        that.amount = response.data.data.length;
                    });
            }
        },
        mounted() {
            this.getTimesheets();
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-component-icon{
        background-color: #ED7003;
    }
    .timesheets-to-approve {
        @include clearfix();
        background-color: #ED7003;
        border-radius: $standardBorderRadius;
        padding: 1em;
        font-size: 1em;
        color: #FFF;
        position: relative;

        h1{
            color:#FFF;
        }
        a{
            padding: 0.5em 0.8em;
            background-color: #FFF;
            border-radius: $standardBorderRadius;
            color: #ED7003;
            margin: 0.2em 0 0 0;
            display: inline-block;
            text-decoration: none;
            transition:all 0.1s ease-in-out;
            &:hover{
                background-color: #ffdfd3;
            }
        }
    }
</style>
